module.exports = __webpack_public_path__ + "static/img06-cc99878f4683106a81301ca73a5d126f.jpg";